const storageKey = (bookingId) => `bookingAccess:${bookingId}`;

export const storeBookingAccess = (bookingId, token) => {
  if (!bookingId || !token) return;
  try {
    sessionStorage.setItem(storageKey(bookingId), token);
  } catch {
    /* private mode / quota */
  }
};

export const getBookingAccess = (bookingId) => {
  if (!bookingId) return undefined;
  try {
    return sessionStorage.getItem(storageKey(bookingId)) || undefined;
  } catch {
    return undefined;
  }
};

/** Query params for guest post-purchase APIs. */
export const bookingAccessParams = (bookingId) => {
  const access = getBookingAccess(bookingId);
  return access ? { access } : {};
};
